import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams, PopoverController, ToastController, ViewController} from "ionic-angular";
import {ClubPopoverComponent} from "../../../../components/club-popover/club-popover";
import {ClubMembersListPage} from "../club-member-list/club-member-list";
import {FeedClub} from "../../feed-club/feed-club.component";
import {ClubProvider} from "../../../../providers/club/club";
import {ClubDetails} from "../club-details/club-details";

/**
 * Generated class for the AllClubsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'all-clubs',
  templateUrl: 'all-clubs.html'
})
export class AllClubs implements OnInit{

  title = '';
  clubs = [];
  myClubs = true;
  currUserOwnerOf: any = [];
  currUserId = '';

  constructor(private navParams: NavParams,
              private viewCtrl: ViewController,
              private modalCtrl: ModalController,
              private clubProvider: ClubProvider,
              private toastCtrl: ToastController,
              private popoverCtrl: PopoverController) {
  }

  ngOnInit() {
    this.title = this.navParams.get('title');
    this.clubs = this.navParams.get('clubs');
    this.myClubs = this.navParams.get('myClubs');
    this.currUserOwnerOf = this.navParams.get('currUserOwnerOf');
    this.currUserId = this.navParams.get('currUserId');

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  joinClub(id, name){
    this.clubProvider.join(id).subscribe((res) => {
      if(res.success){
        let toast = this.toastCtrl.create({
          message: 'Vous avez rejoint le club '+name,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.dismiss();
      }else{
        console.log(res)
      }
    })
  }

  // Settings
  presentPopover(event, clubId) {
    let isUserOwner = false;
    this.currUserOwnerOf.includes(clubId) ? isUserOwner = true : isUserOwner = false;

    let popover = this.popoverCtrl.create(ClubPopoverComponent, {clubId: clubId, userId: this.currUserId, isUserOwner: isUserOwner}, {
      cssClass: 'my-popover'
    });
    popover.onDidDismiss(() => {
      this.dismiss();
    });
    popover.present({
      ev: event
    });
  }


  showMembers(clubId){
    let modal = this.modalCtrl.create(ClubMembersListPage, {clubId: clubId})
    modal.present().then(() => {});
  }

  seeFeedClub(club) {
    let modal = this.modalCtrl.create(FeedClub, {club: club});
    modal.present().then(() => {});
  }

  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
  }

  viewClub(club) {
    this.modalCtrl.create(ClubDetails, {club: club}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/network/all-clubs/all-clubs.ts